/**
 * 需要想定 確定完了 結果モーダル (design L998-1020)。
 *
 * ConfirmDemandForecast 成功後に、対象日・ワークフローID・確定時刻を示す結果を
 * 表示する (旧実装はダイアログを閉じるのみだった)。
 */
import { useTranslation } from 'react-i18next'

import { PrimaryButton, Stack, Text } from '@enechain/ecloud-designsystem'

import { Modal } from '~/components/common/Modal'
import { formatDateTimeLocaleJa } from '~/models/dateTime'

type Props = {
  isOpen: boolean
  targetDateLabel: string
  /** ワークフローケース UUID。workflowId 未解決時の表示フォールバックに使う。 */
  caseId: string | undefined
  /**
   * human-readable なワークフロー業務キー (例: `D0-20260729-27D5`、spec
   * workflow.md AC-CID-001)。表示はこちらを優先する。
   */
  workflowId: string | undefined
  /** 確定時刻 (client 側で記録。backend は confirmed_at を返さない) */
  confirmedAt: Date | undefined
  onClose: () => void
}

export const ConfirmResultDialog = ({
  isOpen,
  targetDateLabel,
  caseId,
  workflowId,
  confirmedAt,
  onClose,
}: Props): React.ReactElement => {
  const { t } = useTranslation()

  const confirmedAtLabel =
    confirmedAt !== undefined ? formatDateTimeLocaleJa(confirmedAt) : '—'

  const footer = (
    <PrimaryButton onClick={onClose}>{t('common:action.ok')}</PrimaryButton>
  )

  return (
    <Modal
      footer={footer}
      isOpen={isOpen}
      onClose={onClose}
      // 幅は UI 辞書 components.md `.ecl-modal` の 4 段 (既定 md)。 8080 `#dft-confirm-result` は既定幅の `ecl-modal`
      size="md"
      title={t('page:demandForecastDaily.confirmResult.title')}
    >
      <Stack gap={3}>
        <Text>
          {t('page:demandForecastDaily.confirmResult.summary', {
            date: targetDateLabel,
          })}
        </Text>
        <Stack gap={1}>
          <Text color="Text.midEmphasis" fontSize="sm">
            {t('page:demandForecastDaily.confirmResult.caseId')}
          </Text>
          <Text fontVariantNumeric="tabular-nums">
            {workflowId !== undefined && workflowId !== ''
              ? workflowId
              : (caseId ?? '—')}
          </Text>
        </Stack>
        <Stack gap={1}>
          <Text color="Text.midEmphasis" fontSize="sm">
            {t('page:demandForecastDaily.confirmResult.confirmedAt')}
          </Text>
          <Text fontVariantNumeric="tabular-nums">{confirmedAtLabel}</Text>
        </Stack>
      </Stack>
    </Modal>
  )
}
